import * as angular from 'angular';
import * as actionCreators from './actionCreators';
import { serviceModule } from '../services/services.module';
import { registerServiceId } from '../registration.helper';

const actionCreatorModuleId = 'wt-action-creators';
const actionCreatorModule = angular.module(actionCreatorModuleId, [serviceModule]);

registerServiceId(actionCreators, actionCreatorModule);

export default actionCreatorModuleId;